import { IOptionType } from '@zz2/zz2-ui';
import { IUserToken } from '../../@types/model/auth/userToken/userToken';

const SESSION_KEY = 'zz2-person-session-token';

const SELECTED_USER_DIVISIONS_KEY = 'person-selected-user-divisions';
const SELECTED_USER_PRINT_SERVER_KEY = 'person-selected-user-PrintServers';

let sessionCallback : (userToken : IUserToken | null) => void;

/*================================================================================================================
*                                              Sessions
* ==============================================================================================================*/

export async function getLocalStorageSession() : Promise<IUserToken | null> {
    let session : IUserToken | null = null;

    session = getSessionLocalStorage();

    if (session) return session;

    return null;
}

export async function setLocalStorageSession(userToken : IUserToken | null) : Promise<void> {
    setSessionLocalStorage(userToken);
    
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (sessionCallback) {
        sessionCallback(userToken);
    }
}

function setSessionLocalStorage(userToken : IUserToken | null) : void {
    if (userToken) {
        localStorage.setItem(SESSION_KEY, JSON.stringify(userToken));
    } else {
        localStorage.removeItem(SESSION_KEY);
    }
}

function getSessionLocalStorage() : IUserToken | null {
    const session = localStorage.getItem(SESSION_KEY);

    if (session) return JSON.parse(session);

    return null;
}

/**
 * Stores User Selected Division Ids
 */
export function setUserSelectedDivisionsLocalStorage(selectedDivisionOptions ?: Array<IOptionType>) : void {
    if (selectedDivisionOptions) {
        localStorage.setItem(SELECTED_USER_DIVISIONS_KEY, JSON.stringify(selectedDivisionOptions));
    } else {
        localStorage.removeItem(SELECTED_USER_DIVISIONS_KEY);
    }
}

/**
 * Retrieves User Selected Division Ids
 */
export function getUserSelectedDivisionsLocalStorage() : Array<IOptionType> {
    const selectedDivisionOptions = localStorage.getItem(SELECTED_USER_DIVISIONS_KEY);

    if (selectedDivisionOptions) return JSON.parse(selectedDivisionOptions);

    return [];
}

/**
 * Stores User Selected Print Server Ids
 */
export function setUserSelectedPrintServersLocalStorage(selectedPrintServerOptions ?: Array<IOptionType>) : void {
    if (selectedPrintServerOptions) {
        localStorage.setItem(SELECTED_USER_PRINT_SERVER_KEY, JSON.stringify(selectedPrintServerOptions));
    } else {
        localStorage.removeItem(SELECTED_USER_PRINT_SERVER_KEY);
    }
}

/**
 * Retrieves User Selected PrintServer Ids
 */
export function getUserSelectedPrintServersLocalStorage() : Array<IOptionType> {
    const selectedPrintServerOptions = localStorage.getItem(SELECTED_USER_PRINT_SERVER_KEY);

    if (selectedPrintServerOptions) return JSON.parse(selectedPrintServerOptions);

    return [];
}

/*================================================================================================================
*                                              Indexed DB
* ==============================================================================================================*/

/**
 * Specifies the callback that will be fired whenever the auth session undergoes a change.
 * @param callback
 */
export async function onSessionChanged(callback : (userToken : IUserToken | null) => void) : Promise<void> {
    sessionCallback = callback;

    const session = getSessionLocalStorage();

    sessionCallback(session);
}